'use client'

import { motion } from 'motion/react'
import grrenLogoImage from '../assets/green-logo.png'
import Image from 'next/image'
export default function Loader() {
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-[#0a0a0a]'>
            <div className='flex flex-col items-center gap-6'>
                <motion.div
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5 }}
                    className='text-4xl font-black tracking-tighter text-[#b4ff00]'
                >
                    <Image src={grrenLogoImage} alt='Disporty' className='object-contain w-auto h-[90px]' />
                </motion.div>
                <div className='flex gap-2'>
                    {[0, 1, 2].map(i => (
                        <motion.div
                            key={i}
                            className='h-3 w-3 rounded-full bg-[#b4ff00]'
                            animate={{
                                y: ['0%', '-50%', '0%'],
                                opacity: [1, 0.5, 1]
                            }}
                            transition={{
                                duration: 0.8,
                                repeat: Infinity,
                                delay: i * 0.2,
                                ease: 'easeInOut'
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}
